import { getData } from "@/lib/prismic/data";
import { PageDocument } from "@/prismicio-types";
import { components } from "@/slices";
import { cn } from "@/lib/utils";
import { SliceZone } from "@prismicio/react";
import { notFound } from "next/navigation";
import { use } from "react";

const Page = ({ resolution }: TemplateProps) => {
  const document = use(getData(resolution)) as PageDocument;

  if (!document?.data) return notFound();

  const startsWithHero = document.data.slices[0]?.slice_type === "hero_interne";

  return (
    <div className={cn("container px-4 xl:px-7.5", !startsWithHero && "pt-5")}>
      <SliceZone
        slices={document.data.slices}
        components={components}
        context={{ locale: resolution.locale, richtextVariant: "default" }}
      />
    </div>
  );
};

export default Page;
